export default __webpack_public_path__ + "25f8bc342aefea61198eaa484f79f7e5.png";